/* eslint-disable import/no-extraneous-dependencies */
import {clientConfig} from '@modifi/client-config'
import EncodeJson from 'mappersmith/middleware/encode-json'
import Retry from 'mappersmith/middleware/retry/v2'
import Timeout from 'mappersmith/middleware/timeout'
import Duration from 'mappersmith/middleware/duration'
import ms from 'ms'
import {correlationIdMiddleware, forge, Middleware} from '@modifi/api-clients'
import {registerGlobalFunction} from '@modifi/utilities'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
const clientFactory = ({additionalMiddleware}: {additionalMiddleware?: Middleware[]} = {}) => {
  const {REACT_APP_BLOG_TAGS: tagFilters} = process.env
  const client = forge({
    clientId: '@modifi/socrates::client',
    middlewares: [
      Retry({
        retries: 2,
      }),
      EncodeJson,
      Timeout(ms('30s')),
      correlationIdMiddleware,
      Duration,
      ...(additionalMiddleware || []),
    ],
    host: clientConfig.get('service_cms', 'https://cms-api.modifi.com') as string,
    resources: {
      Posts: {
        list: {
          path: '/api/v1/cms/blog/posts',
          method: 'get',
          params: {tags: typeof tagFilters !== 'undefined' ? tagFilters.split(',') : undefined},
        },
        fetch: {path: '/api/v1/cms/blog/posts/{slug}', method: 'get'},
      },
      Categories: {
        list: {
          path: '/api/v1/cms/blog/categories',
          method: 'get',
          params: {tags: typeof tagFilters !== 'undefined' ? tagFilters.split(',') : undefined},
        },
      },
      Page: {
        fetch: {path: '/api/v1/cms/pages/{pageType}/{pageSlug}', method: 'get'},
      },
      Collections: {
        fetch: {path: '/api/v1/cms/collections/{collectionName}', method: 'get'},
      },
    },
  })

  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    registerGlobalFunction(window)('platon.socratesClient', client)
  }

  return client
}

export default clientFactory
